if (!window.Eurus.loadedScript.includes('bexit-locales-form.js')) {
  window.Eurus.loadedScript.push('bexit-locales-form.js')

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('bexitLocalizationForm', () => ({
        openCountry: false,
        loading: false,
        cachedResults: false,
        textValue: '',
        checkShow(name) {
          if (!name || !this.textValue) {
            return true
          }

          const lowerCaseName = name.toLowerCase()
          const lowerCaseText = this.textValue.toLowerCase()

          return lowerCaseName.includes(lowerCaseText)
        },
        onChange(value) {
          this.textValue = value
        },
        clearText() {
          this.textValue = ''
        },
        submit({ country, locale }) {
          if (country) {
            const countryInput = document.querySelector('#country_code')

            if (countryInput) {
              countryInput.value = country
            }
          }

          if (locale) {
            const localeInput = document.querySelector('#locale_code')

            if (localeInput) {
              localeInput.value = locale
            }
          }

          const form = document.querySelector('#localization_form')

          if (form) {
            form.submit()
          }
        },
        openCountrySelector() {
          requestAnimationFrame(() => {
            Alpine.store('xQuickView').close()
            Alpine.store('xMiniCart').hideCart()
          })

          requestAnimationFrame(() => {
            document.getElementById('sticky-header').classList.remove('on-scroll-up-animation')

            requestAnimationFrame(() => {
              document.getElementById('sticky-header').classList.remove('header-up')
              Alpine.store('xPopup').open = true
              this.openCountry = true
            })

            if (Alpine.store('xHeaderMenu').stickyType == 'on-scroll-up') {
              setTimeout(() => {
                requestAnimationFrame(() => {
                  document.getElementById('sticky-header').classList.add('on-scroll-up-animation')
                })
              }, 200)
            }
          })
        },
        hideCountrySelector() {
          requestAnimationFrame(() => {
            this.openCountry = false
            Alpine.store('xPopup').open = false
          })
        },
      }))
    })
  })
}
